<template>
  <div class="request_for_demo_popup">
    <div class="request_for_demo_popup_inner">
      <div class="request_for_demo_popup_center">
        <div class="request_for_demo_popup_modal">
          <div class="request_for_demo_popup_header">
            <h4>Update demo request</h4>
            <p class="request_for_demo_blurb">Demo requests can only be scheduled at least 24 hours in advance. You may
              select any available time slot beyond the 24-hour window.</p>
            <i class="fa fa-times-circle-o" aria-hidden="true" @click="backToFirstScreenMethod"></i>
          </div>
          <div class="request_for_demo_section_body">
            <form @submit.prevent="demoForRequestSubmitMethod">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-6 custom_datetime_picker" :class="live_demo_site ? 'active' : ''">
                        <label>Live Demo Date <span class="star_required">*</span>
                        </label>
                        <date-picker v-model="live_demo_site" :disable="datetimeConfig" :min="minDatetime"
                          v-validate="'required'" type="date" :auto-submit="true"
                          v-bind:class="{ 'is-invalid': errors.has('live_demo_site') }"></date-picker>
                        <input type="hidden" v-validate="'required'"
                          v-bind:class="{ 'is-invalid': errors.has('live_demo_site') }" v-model="live_demo_site"
                          name="live_demo_site" data-vv-as="live demo date" style="display: none !important;" />
                        <small class="invalid-feedback" v-if="errors.has('live_demo_site')">{{
                          errors.first('live_demo_site') }}</small>
                      </div>
                      <div class="col-sm-6 signup_fields_multiselect">
                        <div class="form-group multiselect_dropdown_ui">
                          <label>Timzone<span class="star_required">*</span></label>
                          <multiselect v-model="selectedTimeZone" label="name" track-by="value"
                            :options="slotTimeListArr" :option-height="104" :multiple="false" v-validate="'required'"
                            v-bind:class="{ 'is-invalid': errors.has('selectedTimeZone') }" name="selectedTimeZone"
                            placeholder="" :show-labels="false">
                            <span slot="noResult">No elements found.</span>
                          </multiselect>
                          <small class="invalid-feedback" v-if="errors.has('selectedTimeZone')">The field is
                            required</small>
                        </div>
                      </div>
                      <div class="col-sm-6 signup_fields_multiselect" v-if="selectedTimeZone">
                        <div class="form-group multiselect_dropdown_ui">
                          <label>Live Demo Slot<span class="star_required">*</span></label>
                          <multiselect v-model="selectedTimeSlot"
                            :options="disabledBookedSlotsMethod(selectedTimeZone.value.time_slots_24hr)"
                            :option-height="104" :multiple="false" v-validate="'required'"
                            v-bind:class="{ 'is-invalid': errors.has('selectedTimeSlot') }" name="selectedTimeSlot"
                            placeholder="" :show-labels="false">
                            <span slot="noResult">No elements found.</span>
                          </multiselect>
                          <small class="invalid-feedback" v-if="errors.has('selectedTimeSlot')">The field is
                            required</small>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Reason</label>
                          <textarea rows="4" class="form-control" v-model="reason_for_update" v-validate="'required'"
                            v-bind:class="{ 'is-invalid': errors.has('reason_for_update') }" name="reason_for_update"
                            style="height:auto;padding-top:10px;"></textarea>
                          <small class="invalid-feedback" v-if="errors.has('reason_for_update')">The field is
                            required</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-primary register_now_btn"
                    :disabled="submitted || (live_demo_site == `${this.info.date}T00:00:00.000Z`)">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */

import VueDatetimeJs from 'vue-datetime-js';
import Multiselect from 'vue-multiselect'
import { bus } from '@/main';
import moment from 'moment';
import toast from '@/services/toast';

export default {
  name: 'update-demo-request-popup',
  components: {
    Multiselect,
    datePicker: VueDatetimeJs,
  },
  props: [
    'info'
  ],
  data() {
    return {
      live_demo_site: '',
      submitted: false,
      select_option: 'company',
      minDatetime: '',
      slotTime: '',
      slotTimeList: null,
      slotTimeListArr: [],
      selectedTimeZone: null,
      selectedTimeSlot: '',
      reason_for_update: '',
      datetimeConfig: ['Sunday', 'Saturday'],
      bookedSlots: []
    }
  },
  computed: {
  },
  mounted() {
    this.live_demo_site = `${this.info.date}T00:00:00.000Z`;
    this.selectedTimeSlot = this.info.user_timeslot;
    this.minDatetime = this.getTomorrowDate();

    this.$store.dispatch('getTimeSlotsWithZoneAction').then((res) => {
      this.slotTimeList = res.data.timezones;
      if (!this.slotTimeList) return;
      this.slotTimeListArr = Object.entries(this.slotTimeList).map(([name, value]) => ({ name, value }));
      let slotData = this.slotTimeListArr.find(item => item.name === this.info.user_timezone);
      this.selectedTimeZone = slotData;
    });
    this.$store.dispatch('alreadyBookedSlotListAction').then((res) => {
      this.bookedSlots = res.data.data.booked_slots;
    });
  },
  methods: {
    getTomorrowDate() {
      const selectedDateString = this.info.date;
      const selectedDate = new Date(selectedDateString + 'T00:00:00');
      if (isNaN(selectedDate.getTime())) {
        console.error("Invalid date format in this.info.date");
        return null;
      }
      const nextDay = new Date(selectedDate);
      nextDay.setDate(selectedDate.getDate() + 1);
      const year = nextDay.getFullYear();
      const month = String(nextDay.getMonth() + 1).padStart(2, '0');
      const day = String(nextDay.getDate()).padStart(2, '0');
      const formattedNextDay = `${year}-${month}-${day}`;
      return formattedNextDay;
    },
    disabledBookedSlotsMethod(slots) {
      const timezoneMap = {
        'IST': 'Asia/Kolkata',
        'JST': 'Asia/Tokyo',
        'GMT': 'Europe/London',
        'BST': 'Europe/London',
        'EDT': 'America/New_York',
        'CDT': 'America/Chicago',
        'PDT': 'America/Los_Angeles',
        'CST': 'America/Chicago',
        'ART': 'America/Argentina/Buenos_Aires',
      };

      const targetDate = this.live_demo_site;
      const targetTimezoneAbbr = this.selectedTimeZone.name;

      const targetIANA = timezoneMap[targetTimezoneAbbr] || targetTimezoneAbbr;

      const bookedUTCSeconds = this.bookedSlots.map(slot => {
        const dateTimeString = `${slot.date} ${slot.user_timeslot}`;
        const bookedTimezoneAbbr = slot.user_timezone;
        const bookedIANA = timezoneMap[bookedTimezoneAbbr] || bookedTimezoneAbbr;
        const utcMoment = moment.tz(dateTimeString, 'YYYY-MM-DD HH:mm', bookedIANA);
        return utcMoment.utc().format('YYYY-MM-DD HH:mm');
      });

      this.schedulingActivationDateTime = `${this.info.date} ${this.info.user_timeslot}`;
      this.schedulingActivationTimezone = this.info.user_timezone;

      const manualStartDateTimeString = this.schedulingActivationDateTime;
      const manualStartTimezoneAbbr = this.schedulingActivationTimezone;
      const manualStartIANA = timezoneMap[manualStartTimezoneAbbr] || manualStartTimezoneAbbr;
      const manualStartMoment = moment.tz(manualStartDateTimeString, 'YYYY/MM/DD HH:mm', manualStartIANA);
      const twentyFourHoursFromManualStartUTC = manualStartMoment.clone().add(24, 'hours').utc();

      const available_slots = slots.filter(slotTime => {
        const currentDateTimeString = `${targetDate} ${slotTime}`;
        const currentSlotMoment = moment.tz(currentDateTimeString, 'YYYY/MM/DD HH:mm', targetIANA);

        const currentSlotUTCMoment = currentSlotMoment.utc();

        const currentSlotUTCKey = currentSlotUTCMoment.format('YYYY-MM-DD HH:mm');
        const isBooked = bookedUTCSeconds.includes(currentSlotUTCKey);

        const isTooSoon = currentSlotUTCMoment.isSameOrBefore(twentyFourHoursFromManualStartUTC);

        return !isBooked && !isTooSoon;
      });

      return available_slots;
    },
    backToFirstScreenMethod() {
      bus.$emit('updateRequestPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    },
    handleSelect(selectedValue) {
      const localNow = moment();
      const timePart = localNow.format(selectedValue);
      const datePart = moment(this.live_demo_site).format('YYYY-MM-DD');
      const desiredFormatTimestamp = `${datePart} ${timePart}`;
      return desiredFormatTimestamp;
    },
    demoForRequestSubmitMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            title: this.info.title,
            date: moment(this.live_demo_site).format('YYYY-MM-DD'),
            time: this.handleSelect(this.selectedTimeSlot),
            timezone: this.selectedTimeZone.name,
            timeslot: this.selectedTimeSlot,
            id: this.info.id,
            email: this.info.email,
            reason_for_update: this.reason_for_update
          }
          console.log(data)
          this.$store.dispatch('updateDemoRequestAction', data)
            .then((res) => {
              this.backToFirstScreenMethod();
              toast.success(res.data.msg || 'Request processed successfully.');
              this.submitted = false;
            }).catch((err) => {
              this.submitted = false;
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
.request_for_demo_popup {
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  min-height: 100dvh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 1000;
  display: flex;
  align-items: center;

  .request_for_demo_popup_inner {
    margin: 0 auto;
    max-width: 645px;
    width: 100%;
  }

  .request_for_demo_popup_modal {
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    margin: 0 auto;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    position: relative;
  }

  .request_for_demo_popup_header {
    padding: 20px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h4 {
      font-size: 30px;
      letter-spacing: 0;
      margin-bottom: 15px;
      color: #ffd400;
      font-family: 'origin_tech_demoregular';
    }

    .request_for_demo_blurb {
      font-size: 16px;
      color: #fff;
      margin: 0;
      line-height: 1.3;
      text-align: justify;
    }

    .fa-times-circle-o {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 35px;
      color: #e4002b;
      z-index: 10;
      cursor: pointer;

      &:hover {
        color: #ffd400;
      }
    }
  }

  .request_for_demo_section_body {
    padding: 20px;
    position: relative;

    // overflow-y: auto;
    // &::-webkit-scrollbar{width:4px;background: #00000016;}
    // &::-moz-scrollbar{width:4px;background: #00000016;}
    // &::-webkit-scrollbar-thumb{background-color: #232323;}
    // &::-moz-scrollbar-thumb{background-color: #232323;}
    @media only screen and (max-width:767px) {
      height: calc(100dvh - 240px);
    }

    label {
      font-size: 18px;
      margin-bottom: 5px;
      color: #ffd400;
    }

    .form-group {
      margin-bottom: 10px;
    }

    .form-control {
      width: 100%;
      height: 48px;
      font-weight: normal;
      font-size: 18px;
      border-radius: 5px;
      padding: 0 20px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: none;
      outline: none !important;
      box-shadow: none !important;
      color: #ffd400;
      background: rgba(255, 255, 255, 0.08);

      &:focus,
      &.active {
        border: 1px solid #ffd400;
      }

      &::placeholder,
      &::-webkit-input-placeholder,
      &::-moz-placeholder {
        color: rgba(255, 255, 255, 0.3);
      }

      &:focus::-webkit-input-placeholder {
        font-size: 0;
      }

      &:focus::-moz-placeholder {
        font-size: 0;
      }

      &.custom_style_of_datetime {
        background: none;
        padding: 0px;
        border: none;
      }

      option {
        color: black;
      }
    }

    .invalid-feedback {
      font-size: 14px;
      line-height: 1;
      color: #ff2400;
    }

    .register_now_btn {
      background: none;
      border: 2px solid #ffe400;
      color: #ffe400;
      // text-transform: uppercase;
      font-size: 22px;
      padding: 10px 20px;
      line-height: 1;
      height: auto;
      border-radius: 6px;
      box-shadow: none !important;
      outline: none !important;
      // font-family: 'ACETONE';
      line-height: 1;

      &:hover {
        background: #ffe400;
        color: #000000;
      }
    }
  }

  .custom_radio_btn_for_demo {

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }

    [type="radio"]:checked+label,
    [type="radio"]:not(:checked)+label {
      position: relative;
      padding-left: 28px;
      cursor: pointer;
      line-height: 20px;
      display: inline-block;
      color: #ffd400;
    }

    [type="radio"]:checked+label:before,
    [type="radio"]:not(:checked)+label:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 20px;
      height: 20px;
      border: 3px solid #ffd400;
      border-radius: 100%;
      // background: #fff;
    }

    [type="radio"]:checked+label:after,
    [type="radio"]:not(:checked)+label:after {
      content: '';
      width: 12px;
      height: 12px;
      background: #ffd400;
      position: absolute;
      top: 4px;
      left: 4px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }

    [type="radio"]:not(:checked)+label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    [type="radio"]:checked+label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  .font_style_change {
    select.form-control {
      font-size: 0px !important;

      option {
        font-size: 18px !important;
      }
    }
  }
}
</style>